import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { formatTime } from '../../../utils/videojs'
import { videoElementAtom } from './atoms'

//* =========================== React Component ================================

const TimeDisplay = (): JSX.Element => {
  const [elapsed, setElapsed] = useState('0:00')
  const [duration, setDuration] = useState('0:00')
  const [videoElement] = useAtom(videoElementAtom)

  useEffect(() => {
    if (!videoElement) {
      return
    }
    videoElement.addEventListener('timeupdate', () => {
      setElapsed(formatTime(videoElement.currentTime, videoElement.duration))
    })
    videoElement.addEventListener('loadedmetadata', () => {
      setDuration(formatTime(videoElement.duration, videoElement.duration))
    })
  }, [videoElement])

  return (
    <Wrapper>
      <ElapsedTimeText>{`${elapsed} / ${duration}`}</ElapsedTimeText>
    </Wrapper>
  )
}

export default TimeDisplay

//* ============================== Styled Components ===========================

const ElapsedTimeText = styled.div`
  color: #ffffff;
  font-weight: 400;
  font-size: 15px;
  white-space: nowrap;
`

const Wrapper = styled.div`
  user-select: none;
`
